import type { SVGProps } from "react";
export function ProjectIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-slot="icon"
      fill="none"
      height={20}
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 20 20"
      width={20}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.512 0A3.49 3.49 0 0 1 20 3.488v13.024A3.49 3.49 0 0 1 16.512 20H3.488A3.49 3.49 0 0 1 0 16.512V8.91c0-.678.27-1.329.749-1.808L7.102.749A2.56 2.56 0 0 1 8.91 0zm-7.21 5.349a3.49 3.49 0 0 1-3.489 3.488H1.4l-.003.073v7.602c0 1.156.936 2.092 2.092 2.093h13.024a2.093 2.093 0 0 0 2.093-2.093V3.488a2.093 2.093 0 0 0-2.093-2.092h-7.21zM2.383 7.44h3.431A2.093 2.093 0 0 0 7.907 5.35V1.917z"
        fill="currentColor"
      />
    </svg>
  );
}
